/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "common": {
            "nested": {
              "EndpointInfo": {
                "fields": {
                  "geoLocation": {
                    "type": "squareup.common.location.GeoLocation",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "userAgent": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "deviceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "deviceInstallationId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deviceMacSha1": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "deviceName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "osDeviceId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "osType": {
                    "type": "squareup.esperanto.common.EndpointInfo.OsType",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "OsType": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "ANDROID": 1,
                      "IOS": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.EndpointInfo && !$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.EndpointInfo?.nested?.OsType) {
  $root.addJSON(jsonData);
}

/**
 * Endpoint information such as location, time zone, device id, etc.
 *
 * SOURCE EndpointInfo @ squareup/esperanto/common/endpoint_info.proto at 14:1
 */
export const EndpointInfo = $root.lookupType('squareup.esperanto.common.EndpointInfo');
fixType(EndpointInfo);
Builder.createAndAttachToType(EndpointInfo);
/**
 * SOURCE OsType @ squareup/esperanto/common/endpoint_info.proto at 48:3
 */
EndpointInfo.OsType = $root.lookupEnum('squareup.esperanto.common.EndpointInfo.OsType').values;